<template>
  <PopUp :model-value="isOpen" size="sm" @update:model-value="v => !v && emit('close')">
    <!-- Header -->
    <div class="flex items-center justify-between px-6 pt-5 pb-4 border-b border-black/[0.06]">
      <h3 class="text-[1.6rem] font-bold text-[#0f1f2e]">{{ t("joinedSessionTitle") }}</h3>
      <button
        class="w-8 h-8 rounded-full hover:bg-slate-100 flex items-center justify-center text-slate-400 transition"
        @click="emit('close')"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
    </div>

    <!-- Body -->
    <div class="px-6 py-6 flex flex-col items-center gap-4 text-center">
      <div class="w-14 h-14 rounded-full bg-green-50 flex items-center justify-center">
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#22c55e" stroke-width="2.5" stroke-linecap="round"><path d="M20 6L9 17l-5-5"/></svg>
      </div>
      <p class="text-[1.45rem] text-[#3d5a6e] leading-relaxed">{{ t("joinedSessionBody") }}</p>
    </div>

    <!-- Actions -->
    <div class="px-6 pb-6 flex flex-col gap-2">
      <button
        class="w-full py-3 rounded-xl bg-[#4885d0] text-white text-[1.4rem] font-semibold hover:opacity-90 transition flex items-center justify-center gap-2"
        @click="emit('share')"
      >
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
        {{ t("shareSession") }}
      </button>
      <button
        class="w-full py-2.5 rounded-xl text-[1.35rem] text-[#7a9aaa] hover:text-[#0f1f2e] transition"
        @click="emit('close')"
      >{{ t("close") }}</button>
    </div>
  </PopUp>
</template>

<script setup lang="ts">
import { useLiveGroups } from "@/components/companionGroups/useLiveGroups";
import PopUp from "@/components/popup/PopUp.vue";

defineProps<{
  isOpen: boolean;
}>();

const emit = defineEmits<{
  (e: "close"): void;
  (e: "share"): void;
}>();

const { t } = useLiveGroups(
  { _skipInit: true },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  (_e: any, ..._args: any[]) => {},
);
</script>
